<template>
     <v-dialog
      :value="showDlg"
      :max-width="maxWidth"
      persistent 
    >
    <v-card>
        <v-card-title :class="titleClass">{{title}}</v-card-title>
        <v-card-text class="mt-4">{{message}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="buttons.OKButton" text @click="submit">{{submitButtonCaption}}</v-btn>
          <v-btn color="primary" v-if="buttons.CancelButton" text @click="cancel">{{cancelButtonCaption}}</v-btn>
          <v-btn color="primary" v-if="buttons.CloseButton" text @click="close">{{closeButtonCaption}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
export default {
    name:"AppConfirmDialog",
    props:{
        title:{
            type:String,
            default:""
        },
        message:{
            type:String,
            default:""
        },
        buttons:{
            type:Object,
            default(){
                return {};
            }
        },
        showDlg:{
            type:Boolean,
            default:false
        },
        maxWidth:{
            type:Number,
            default:400
        },
        submitCallback:{
            type:Function,
            default(){
                return ()=>{};
            }
        },
        type:{
            type:String,
            default:null
        },
        cancelCallback:{
            type:Function,
            default(){
                return ()=>{};
            }
        },
        closeCallback:{
            type:Function,
            default(){
                return ()=>{};
            }
        },
    },
    computed:{
        submitButtonCaption(){
            return (this.buttons.OKButton && this.buttons.OKButton.Caption)?this.buttons.OKButton.Caption:"OK";
        },
        cancelButtonCaption(){
            return (this.buttons.CancelButton && this.buttons.CancelButton.Caption)?this.buttons.CancelButton.Caption:"Cancel";
        },
        closeButtonCaption(){
            return (this.buttons.CloseButton && this.buttons.CloseButton.Caption)?this.buttons.CloseButton.Caption:"Close";
        },
        titleClass(){
            let clazz="headline custom-title ";
            if(this.type == "Error"){
                clazz +="red darken-1 white--text";
            }else{
                clazz +="teal white--text";
            }

            return clazz;
        }
    },
    methods:{
        submit(){
            if(this.submitCallback && typeof this.submitCallback === "function"){
                this.submitCallback();
            }

            this.$store.dispatch("closeConfirmDialog");
        },
        cancel(){
            if(this.cancelCallback && typeof this.cancelCallback === "function"){
                this.cancelCallback();
            }
           
            this.$store.dispatch("closeConfirmDialog");
        },
        close(){

            if(this.closeCallback && typeof this.closeCallback === "function"){
                this.closeCallback();
            }
            this.$store.dispatch("closeConfirmDialog");
        }
    }

}
</script>
<style lang="scss" scoped>
.custom-title{
    height:40px;
    padding-top:8px !important;
}
</style>